import React, { useState, useEffect } from "react";
import { ApplicationApi, StatusResponse, LoanApi, LoanRequest } from "../../lib-api";
import ApplicationContainer from "../applicationContainer";
import ApplicationContent from "../applicationContent";
import TopStripIndicator from "./topStripIndicator";
import { StringUtil } from "../../util/stringUtil";
import { apiConfiguration } from "../../api-configuration";
import { Button, Row, Col } from "reactstrap";
import { trackEvent } from "../../util/gtm";

interface Props {
    data: StatusResponse;
    referenceId: number;
}

const ApplicationDeclined: React.FunctionComponent<Props> = props => {
    const [data, setData] = useState<LoanRequest>();

    
    useEffect(() => {
        const loadLoans = async () => {
            const api = new LoanApi(apiConfiguration);
            try {
                const response = await api.apiLoansAmountGet({
                    amount: props.data.loanAmount
                });
                setData(response);
            }
            catch (err) {
               
            }
            
        };
        loadLoans();
    
    }, [])

  
    const GAEVENT = (url, amount, headline, number) => {
        const urlParams = new URLSearchParams(url);

        let adservice = ""
        adservice = urlParams.get('sub');
        let digital = "";
        digital = urlParams.get('aff_sub');
        let adtraction = "";
        adtraction = urlParams.get('epi');
        trackEvent(
            "Ansøg",
            headline,
            "@subid:" + (adservice != "" ? adservice : (digital != "" ? digital : (adtraction != "" ? adtraction : "")))
        )
        let group = "";

        if (amount <= 20000) {
            group = "Small"
        }
        else if (amount > 20000 && amount < 51000) {
            group = "Medium"
        }
        else {
            group = "Large"
        }
      

        //trackEvent(
        //    group + " lån " + number + ": " + headline,
        //    "Ansøgt lån",
        //    "Afvist af basisbank: Gruppe " + group
        //)
    }
    const drawLoans = (response) => {
        console.log(response); 

    
        let loans = [];
        for (let i = 0; i < response.length; i++) {
            console.log(i)
            let loan = response[i];
            
            loans.push(
                <Col key={i}   className="loan col-lg-4 col-12">
                    <div className="loan-container-alternative">
                        <div className=" text-center">
                            {loan.imageUrl != null && <h4 className="altLoanLogo"> <img className="logo" src={loan.imageUrl} alt={loan.headline} />
                            </h4>}
                            {loan.imageUrl == null && <h4 className="altLoanLogo">{loan.headline} 
                            </h4>}
                        </div>
                        <Row className="loan-text ">
                            <div className="col-4 text-left"><span><strong>Lånebeløb</strong></span></div>
                            <div className="col-8 text-right"><span>{loan.minLoanAmount.toLocaleString(navigator.language, { minimumFractionDigits: 0 }).replace(",", ".")} - {loan.maxLoanAmount.toLocaleString(navigator.language, { minimumFractionDigits: 0 }).replace(",", ".")} kr</span></div>
                        </Row>
                        <Row className="loan-text ">
                            <div className="col-4 text-left"><span><strong>Tilbagebetaling</strong></span></div>
                            <div className="col-8 text-right"><span>  {loan.minDuration && loan.minDuration}{loan.minDuration && loan.maxDuration && ' -'}  {loan.maxDuration && loan.maxDuration}{loan.timeUnit}</span></div>
                        </Row>
                        <Row className="loan-text ">
                            <div className="col-5 text-left"><span><strong>Rente/år</strong></span></div>
                                {loan.mininterest != 0 && 
                                <div className="col-7 text-right"><span>{loan.minInterest && loan.minInterest}{loan.minInterest && loan.maxInterest &&  ' -'}  {loan.maxInterest && loan.maxInterest}%</span></div>
                            }
                            {loan.mininterest > 0 &&
                                <div className="col-7 text-right"><span>{loan.maxInterest}%</span></div>
                            }
                       
                        </Row>
                        <div className="d-flex">
                            <a href={"linkdirect/" + loan.id + "/" + props.referenceId} target="_blank" onClick={e => GAEVENT(loan.trackingUrl, data.amount, loan.headline, i)}>Ansøg</a>
                        </div>
                        <div className="example-text">
                            Eksempel: Samlet kreditbeløb: {loan.exampleAmount && loan.exampleAmount.toLocaleString(navigator.language, { minimumFractionDigits: 0 }).replace(",", ".")} kr.Løbetid: {loan.exampleMonths} måneder Etabl.omk.{loan.exampleStartCosts} kr. {loan.exampleInterestType} debitorrente: {loan.exampleInterest} % ÅOP: {loan.exampleAAop} % {loan.maxAAop != null && <span>Max ÅOP: {loan.maxAAop}</span>}   Månedlig ydelse: {loan.exampleMonthlyPay} kr. Samlede kredit omk.: {loan.exampleTotalCosts} kr. Samlet tilbagebetalt beløb: {loan.exampleTotalPayback} kr. {loan.extraExampleInfo}
                            </div>
                    </div>
                </Col>


            );
        };
      

        return loans
    }
   
  return (
    <ApplicationContainer>
      <TopStripIndicator />
      <ApplicationContent>
              <h2 className="text-primary pt-3 pb-5">Tak for din ansøgning hos Lendmore</h2>
        <div className="text-center pb-4">
          
                   <p>
                      Din ansøgning er desværre blevet afvist. Heldigvis er der andre muligheder for at blive godkendt til et lån. Vi anbefaler at ansøge ét af lånene nedenfor:<br/><br/>
          </p>
         
              </div>
              <Row className="loan-row">
             
                  {data && props.data.loanAmount <= 20000 && drawLoans(data.smallLoans)}
                  {data && props.data.loanAmount > 20000  &&  props.data.loanAmount < 51000 && drawLoans(data.mediumLoans)}
                  {data && props.data.loanAmount > 50000 && drawLoans(data.largeLoans)}
              </Row>
      </ApplicationContent>
    </ApplicationContainer>
  );
};

export default ApplicationDeclined;
